<template>
  <div
    id="top"
    class="w-100 space-for-navbar mb-3"
  >
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>Team</title>
          <g id="Splashes">
            <g id="Team">
              <image
                width="6237"
                height="3508"
                transform="translate(0.14 0.19) scale(0.16)"
                :xlink:href="require('../assets/purchased_pics/rawpixel-578842-6237x3508.jpg')"
              />
              <g id="TeamLabel">
                <text
                  class="bmg-splashes-15"
                  transform="translate(218.96 101.12)"
                ><tspan class="bmg-splashes-29">T</tspan><tspan
                  class="bmg-splashes-16"
                  x="20.76"
                  y="0"
                >e</tspan><tspan
                  x="44.32"
                  y="0"
                >am</tspan></text>
                <g>
                  <path
                    class="bmg-splashes-30"
                    d="M153.85,122c0-5.13,3.9-8.9,9.18-8.9a8.47,8.47,0,0,1,6.39,2.55l-1.17,1.17a7,7,0,0,0-5.18-2.07,7.25,7.25,0,1,0,0,14.5,6.9,6.9,0,0,0,5.18-2.1l1.17,1.17a8.51,8.51,0,0,1-6.42,2.58A8.78,8.78,0,0,1,153.85,122Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M171.1,124.13a6.69,6.69,0,1,1,6.7,6.7A6.46,6.46,0,0,1,171.1,124.13Zm11.57,0a4.89,4.89,0,1,0-4.87,5.13A4.79,4.79,0,0,0,182.67,124.13Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M200.2,123.08v7.63h-1.78v-7.45c0-2.78-1.44-4.2-3.94-4.2-2.83,0-4.6,1.75-4.6,4.75v6.9H188.1V117.56h1.7V120a5.53,5.53,0,0,1,5-2.52C198,117.46,200.2,119.31,200.2,123.08Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M215.82,117.56,210,130.71h-1.83l-5.82-13.15h1.85l4.92,11.2,5-11.2Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M229.4,124.68h-11a4.87,4.87,0,0,0,5.17,4.58,5.2,5.2,0,0,0,4-1.73l1,1.15a6.95,6.95,0,0,1-12-4.55,6.33,6.33,0,0,1,6.42-6.67c3.7,0,6.37,2.72,6.37,6.67C229.42,124.28,229.4,124.48,229.4,124.68Zm-11-1.32h9.33a4.67,4.67,0,0,0-9.33,0Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M239.67,117.46v1.72l-.42,0c-2.75,0-4.42,1.75-4.42,4.85v6.7h-1.78V117.56h1.7v2.57C235.58,118.38,237.25,117.46,239.67,117.46Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M250.37,129.91a4.23,4.23,0,0,1-2.77.92,3.48,3.48,0,0,1-3.85-3.82v-8H241.4v-1.5h2.35v-2.88h1.78v2.88h4v1.5h-4v7.85a2.1,2.1,0,0,0,2.27,2.4,3,3,0,0,0,1.95-.68Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M253.2,113.41a1.28,1.28,0,0,1,1.3-1.25,1.26,1.26,0,0,1,1.3,1.22,1.3,1.3,0,0,1-2.6,0Zm.4,4.15h1.78v13.15H253.6Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M272.42,123.08v7.63h-1.77v-7.45c0-2.78-1.45-4.2-3.95-4.2-2.82,0-4.6,1.75-4.6,4.75v6.9h-1.77V117.56H262V120a5.51,5.51,0,0,1,5-2.52C270.22,117.46,272.42,119.31,272.42,123.08Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M289.47,117.56v11.55c0,4.52-2.22,6.57-6.57,6.57a9.15,9.15,0,0,1-6.12-2l.9-1.34a7.81,7.81,0,0,0,5.17,1.8c3.32,0,4.85-1.53,4.85-4.78v-1.67a5.94,5.94,0,0,1-5.13,2.55,6.38,6.38,0,1,1,0-12.75,5.94,5.94,0,0,1,5.2,2.62v-2.52Zm-1.72,6.25a5,5,0,1,0-5,4.82A4.7,4.7,0,0,0,287.75,123.81Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M299.7,128.58l.72-1.42a8.63,8.63,0,0,0,5.78,2.12c3.27,0,4.7-1.37,4.7-3.1,0-4.8-10.77-1.85-10.77-8.32,0-2.58,2-4.8,6.44-4.8a9.84,9.84,0,0,1,5.43,1.55l-.63,1.47a9.05,9.05,0,0,0-4.8-1.45c-3.2,0-4.62,1.43-4.62,3.18,0,4.8,10.77,1.9,10.77,8.27,0,2.58-2.05,4.78-6.52,4.78A9.48,9.48,0,0,1,299.7,128.58Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M315.05,124.13a6.47,6.47,0,0,1,6.77-6.67,5.73,5.73,0,0,1,5.15,2.6l-1.32.9a4.46,4.46,0,0,0-3.83-1.95,5.13,5.13,0,0,0,0,10.25,4.44,4.44,0,0,0,3.83-1.93l1.32.9a5.79,5.79,0,0,1-5.15,2.6A6.49,6.49,0,0,1,315.05,124.13Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M330.05,113.41a1.3,1.3,0,1,1,1.3,1.27A1.27,1.27,0,0,1,330.05,113.41Zm.4,4.15h1.77v13.15h-1.77Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M348.62,124.68h-11a4.87,4.87,0,0,0,5.18,4.58,5.18,5.18,0,0,0,4-1.73l1,1.15a6.95,6.95,0,0,1-12-4.55,6.33,6.33,0,0,1,6.42-6.67c3.7,0,6.38,2.72,6.38,6.67C348.65,124.28,348.62,124.48,348.62,124.68Zm-11-1.32H347a4.67,4.67,0,0,0-9.33,0Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M364.37,123.08v7.63H362.6v-7.45c0-2.78-1.45-4.2-4-4.2-2.83,0-4.6,1.75-4.6,4.75v6.9h-1.78V117.56H354V120a5.53,5.53,0,0,1,5-2.52C362.17,117.46,364.37,119.31,364.37,123.08Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M367.92,124.13a6.47,6.47,0,0,1,6.78-6.67,5.74,5.74,0,0,1,5.15,2.6l-1.33.9A4.46,4.46,0,0,0,374.7,119a5.13,5.13,0,0,0,0,10.25,4.44,4.44,0,0,0,3.82-1.93l1.33.9a5.8,5.8,0,0,1-5.15,2.6A6.49,6.49,0,0,1,367.92,124.13Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M394.55,124.68h-11a4.87,4.87,0,0,0,5.17,4.58,5.2,5.2,0,0,0,4-1.73l1,1.15a7,7,0,0,1-12-4.55,6.33,6.33,0,0,1,6.43-6.67c3.7,0,6.37,2.72,6.37,6.67C394.57,124.28,394.55,124.48,394.55,124.68Zm-11-1.32h9.32a4.67,4.67,0,0,0-9.32,0Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M103,159.91a4.25,4.25,0,0,1-2.77.92A3.48,3.48,0,0,1,96.33,157v-7.95H94v-1.5h2.35v-2.88H98.1v2.88h4v1.5h-4v7.85a2.11,2.11,0,0,0,2.28,2.4,3,3,0,0,0,2-.68Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M104.38,154.13a6.69,6.69,0,1,1,6.7,6.7A6.46,6.46,0,0,1,104.38,154.13Zm11.57,0a4.89,4.89,0,1,0-4.87,5.13A4.79,4.79,0,0,0,116,154.13Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M142,149.21c0,3.72-2.7,6-7.15,6h-4.7v5.53H128.3v-17.5h6.55C139.3,143.21,142,145.46,142,149.21Zm-1.85,0c0-2.8-1.85-4.4-5.35-4.4h-4.65v8.75h4.65C138.3,153.56,140.15,152,140.15,149.21Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M155.43,152.56v8.15h-1.7v-2.05a4.94,4.94,0,0,1-4.53,2.17c-3,0-4.8-1.55-4.8-3.82,0-2,1.3-3.73,5.08-3.73h4.17v-.8c0-2.25-1.27-3.47-3.72-3.47a6.72,6.72,0,0,0-4.38,1.55l-.8-1.33a8.4,8.4,0,0,1,5.35-1.77C153.5,147.46,155.43,149.16,155.43,152.56Zm-1.78,4.2v-2.15h-4.12c-2.55,0-3.38,1-3.38,2.35,0,1.52,1.23,2.47,3.33,2.47A4.2,4.2,0,0,0,153.65,156.76Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M167.18,159.91a4.25,4.25,0,0,1-2.78.92,3.48,3.48,0,0,1-3.85-3.82v-7.95H158.2v-1.5h2.35v-2.88h1.78v2.88h4v1.5h-4v7.85a2.1,2.1,0,0,0,2.27,2.4,2.93,2.93,0,0,0,2-.68Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M170,143.41a1.28,1.28,0,0,1,1.3-1.25,1.26,1.26,0,0,1,1.3,1.22,1.3,1.3,0,0,1-2.6,0Zm.4,4.15h1.78v13.15H170.4Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M188.57,154.68h-11a4.87,4.87,0,0,0,5.17,4.58,5.18,5.18,0,0,0,4-1.73l1,1.15a6.95,6.95,0,0,1-12-4.55,6.33,6.33,0,0,1,6.43-6.67c3.69,0,6.37,2.72,6.37,6.67C188.6,154.28,188.57,154.48,188.57,154.68Zm-11-1.32h9.32a4.67,4.67,0,0,0-9.32,0Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M204.32,153.08v7.63h-1.77v-7.45c0-2.78-1.45-4.2-4-4.2-2.82,0-4.6,1.75-4.6,4.75v6.9h-1.77V147.56h1.7V150a5.51,5.51,0,0,1,5-2.52C202.12,147.46,204.32,149.31,204.32,153.08Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M216.07,159.91a4.23,4.23,0,0,1-2.77.92,3.48,3.48,0,0,1-3.85-3.82v-7.95H207.1v-1.5h2.35v-2.88h1.78v2.88h4v1.5h-4v7.85a2.1,2.1,0,0,0,2.27,2.4,2.93,2.93,0,0,0,1.95-.68Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M235.77,152.56v8.15h-1.7v-2.05a4.92,4.92,0,0,1-4.52,2.17c-3,0-4.8-1.55-4.8-3.82,0-2,1.3-3.73,5.07-3.73H234v-.8c0-2.25-1.27-3.47-3.72-3.47a6.72,6.72,0,0,0-4.38,1.55l-.8-1.33a8.4,8.4,0,0,1,5.35-1.77C233.85,147.46,235.77,149.16,235.77,152.56Zm-1.77,4.2v-2.15h-4.12c-2.55,0-3.38,1-3.38,2.35,0,1.52,1.23,2.47,3.32,2.47A4.22,4.22,0,0,0,234,156.76Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M252.7,153.08v7.63h-1.78v-7.45c0-2.78-1.44-4.2-3.94-4.2-2.83,0-4.6,1.75-4.6,4.75v6.9H240.6V147.56h1.7V150a5.53,5.53,0,0,1,5-2.52C250.5,147.46,252.7,149.31,252.7,153.08Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M269.57,142.16v18.55h-1.7v-2.6a5.68,5.68,0,0,1-5.07,2.72,6.69,6.69,0,0,1,0-13.37,5.74,5.74,0,0,1,5,2.6v-7.9Zm-1.75,12a4.89,4.89,0,1,0-4.87,5.13A4.81,4.81,0,0,0,267.82,154.13Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M281.45,143.21h1.85v17.5h-1.85Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M300.72,153.08v7.63H299v-7.45c0-2.78-1.45-4.2-3.95-4.2-2.83,0-4.6,1.75-4.6,4.75v6.9h-1.77V147.56h1.69V150a5.53,5.53,0,0,1,5-2.52C298.52,147.46,300.72,149.31,300.72,153.08Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M316.35,147.56l-5.85,13.15h-1.83l-5.82-13.15h1.85l4.92,11.2,5-11.2Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M329.92,154.68h-11a4.87,4.87,0,0,0,5.18,4.58,5.18,5.18,0,0,0,4-1.73l1,1.15a6.95,6.95,0,0,1-12-4.55,6.33,6.33,0,0,1,6.42-6.67c3.7,0,6.38,2.72,6.38,6.67C330,154.28,329.92,154.48,329.92,154.68Zm-11-1.32h9.33a4.67,4.67,0,0,0-9.33,0Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M331.75,159.21l.8-1.4a8,8,0,0,0,4.67,1.47c2.5,0,3.53-.85,3.53-2.15,0-3.42-8.52-.72-8.52-5.92,0-2.15,1.84-3.75,5.19-3.75a8.91,8.91,0,0,1,4.65,1.22l-.77,1.43a6.76,6.76,0,0,0-3.88-1.13c-2.37,0-3.42.93-3.42,2.18,0,3.55,8.52.87,8.52,5.92,0,2.28-2,3.75-5.42,3.75A8.8,8.8,0,0,1,331.75,159.21Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M352.72,159.91a4.25,4.25,0,0,1-2.77.92A3.48,3.48,0,0,1,346.1,157v-7.95h-2.35v-1.5h2.35v-2.88h1.77v2.88h4v1.5h-4v7.85a2.11,2.11,0,0,0,2.28,2.4,3,3,0,0,0,2-.68Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M354.15,154.13a6.69,6.69,0,1,1,6.7,6.7A6.46,6.46,0,0,1,354.15,154.13Zm11.57,0a4.89,4.89,0,1,0-4.87,5.13A4.79,4.79,0,0,0,365.72,154.13Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M377.77,147.46v1.72l-.42,0c-2.75,0-4.43,1.75-4.43,4.85v6.7h-1.77V147.56h1.7v2.57C373.67,148.38,375.35,147.46,377.77,147.46Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M402.65,143.21l-7.75,17.5h-1.83l-7.75-17.5h2l6.7,15.2,6.75-15.2Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M413.72,152.56v8.15H412v-2.05a4.93,4.93,0,0,1-4.52,2.17c-3,0-4.8-1.55-4.8-3.82,0-2,1.3-3.73,5.07-3.73H412v-.8c0-2.25-1.28-3.47-3.73-3.47a6.68,6.68,0,0,0-4.37,1.55l-.8-1.33a8.36,8.36,0,0,1,5.35-1.77C411.8,147.46,413.72,149.16,413.72,152.56Zm-1.77,4.2v-2.15h-4.13c-2.55,0-3.37,1-3.37,2.35,0,1.52,1.22,2.47,3.32,2.47A4.22,4.22,0,0,0,412,156.76Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M418.55,142.16h1.77v18.55h-1.77Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M437.12,147.56v13.15h-1.7v-2.4a5.21,5.21,0,0,1-4.72,2.52c-3.35,0-5.55-1.87-5.55-5.65v-7.62h1.77V155c0,2.8,1.45,4.22,3.95,4.22,2.75,0,4.48-1.77,4.48-4.77v-6.9Z"
                  />
                  <path
                    class="bmg-splashes-30"
                    d="M453.55,154.68h-11a4.87,4.87,0,0,0,5.17,4.58,5.2,5.2,0,0,0,4-1.73l1,1.15a7,7,0,0,1-12-4.55,6.33,6.33,0,0,1,6.43-6.67c3.7,0,6.37,2.72,6.37,6.67C453.57,154.28,453.55,154.48,453.55,154.68Zm-11-1.32h9.32a4.67,4.67,0,0,0-9.32,0Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="centered-on-page h4">
      <div class="text-dark">
        Filter:
      </div>
      <div class="">
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-investor"
            value="investor"
          >
          <label
            class="form-check-label"
            for="filter-investor"
          >Capital Investor</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-exec"
            value="exec"
          >
          <label
            class="form-check-label"
            for="filter-exec"
          >BMG Executive Team</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-board"
            value="board"
          >
          <label
            class="form-check-label"
            for="filter-board"
          >Advisory Board</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-medical-board"
            value="medical-board"
          >
          <label
            class="form-check-label"
            for="filter-medical-board"
          >Medical Advisory Board</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-founder"
            value="founder"
          >
          <label
            class="form-check-label"
            for="filter-founder"
          >Founder</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-researcher"
            value="researcher"
          >
          <label
            class="form-check-label"
            for="filter-researcher"
          >Researcher</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-consultant"
            value="consultant"
          >
          <label
            class="form-check-label"
            for="filter-consultant"
          >Consultant</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="selectedGroups"
            id="filter-engineer"
            value="engineering"
          >
          <label
            class="form-check-label"
            for="filter-engineer"
          >Engineering</label>
        </div>
      </div>
    </div>
    <!-- <span>Selected Filters: {{ selectedGroups }}</span> -->
    <div class="container">
      <div class="row mt-5">
        <div class="col-md">
          <BioCard
            name="Christian Haller"
            title="Chairman of BMG Advisory Board"
            bio="Developed >100 medical devices, as a principal / board member for medical device startups"
            email="Christian.Haller@BridgingMedical.com"
            phone="+1 (703) 629-2449"
            pic="bmg-bio-pic-haller"
            location="Virginia"
            :show-bio="true"
            :selected="isSelected(['board', 'consultant'])"
            calendly="christian-haller"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Lawrence D. Dorr, MD"
            title="BMG Medical Advisory Board"
            bio="Director, Dorr Institute for Arthritis Research and Education, Keck Hospital – USC, 12,000 hip and knee replacements, past president of Hip Society, Knee Society, American Assoc. of Hip and Knee Surgeons"
            pic="bmg-bio-pic-dorr"
            location="California"
            :show-bio="true"
            :selected="isSelected(['medical-board'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Jonathan Jensen"
            title="BMG Advisory Board"
            bio="Entrepreneur, BMG investor and at large representative of investor interest on board. His wife, Emily is a co-contributor"
            pic="bmg-bio-pic-jensen"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['board', 'consultant', 'investor'])"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <BioCard
            name="Ferenc Toth, DVM, PHD, DACVS-LA"
            title="BMG Medical Advisory Board"
            bio="Large Animal Veterinary Surgeon, Bone Pathology and Growth Expert. BMG Co-Primary Investigator"
            pic="bmg-bio-pic-toth"
            location="Minnesota"
            :show-bio="true"
            :selected="isSelected(['medical-board', 'consultant', 'researcher'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Janik C. Gasiorowski, VMD, DACVS"
            title="BMG Medical Advisory Board"
            bio="Mid-Atlantic Equine Medical Center Owner, Operator, Equine Surgeon. AOVET Faculty. BMG Co-Primary Investigator."
            pic="bmg-bio-pic-gasiorowski"
            location="Pennsylvania"
            :show-bio="true"
            :selected="isSelected(['medical-board', 'consultant', 'researcher', 'investor'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Vicki Anastasi"
            title="Chief Regulatory Advisor"
            bio="25+ yrs medical device experience, exec. &amp; global regulatory approval, startups"
            pic="bmg-bio-pic-anastasi"
            location="Massachusetts"
            :show-bio="true"
            :selected="isSelected(['consultant', 'board', 'medical-board'])"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <BioCard
            name="Robert Patty, PH.D, MBA, PE"
            title="BMG President &amp; CEO, Primary Inventor, Co-Founder, Investor"
            bio="25+ years US &amp; Int’l Operations Excellence Leader, Corporate Operations Ex. VP"
            email="Robert.Patty@BridgingMedical.com"
            phone="+1 (325) 261-2874"
            pic="bmg-bio-pic-robert-patty"
            location="Indiana"
            :show-bio="true"
            :selected="isSelected(['founder', 'engineering', 'exec', 'researcher', 'investor'])"
            calendly="robert-patty"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Cameron Field, DPM"
            title="BMG Chief Medical Officer, Co-Founder, Co-Inventor, Investor"
            bio="Foot &amp; reconstructive rearfoot/ankle surgeon, USAF Academy"
            pic="bmg-bio-pic-field"
            location="Colorado"
            :show-bio="true"
            :selected="isSelected(['founder', 'researcher', 'exec', 'investor'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Daniel Patty, DPM"
            title="BMG Assistant Chief Medical Officer, Co-Founder, Co-Inventor, Investor"
            bio="Utah Trauma, foot &amp; ankle reconstruction Surgeon"
            pic="bmg-bio-pic-daniel-patty"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['founder', 'researcher', 'exec', 'investor'])"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <BioCard
            name="Andrew Enke, MSME, MBA"
            title="BMG Engineering Director, Co-Founder, Co-Inventor"
            bio="Orthopedic Device Engineer, instruments &amp; implants. Entire system for total knee replacement and the instrumentation kit by modeling the parts in 3D CAD and 2D engineering drawings for manufacturing. Documentation and testing for FDA approval"
            pic="bmg-bio-pic-enke"
            location="Washington"
            :show-bio="true"
            :selected="isSelected(['founder', 'engineering', 'exec'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Aaron Patty, BSCS, MBA"
            title="BMG VP Operations &amp; General Manager, Co-Founder, Investor"
            bio="15+ yrs systems engineering. Serial Entrepreneur. US &amp; international contract management. Telemetry equipment and software design."
            pic="bmg-bio-pic-aaron-patty"
            location="Maryland"
            :show-bio="true"
            :selected="isSelected(['founder', 'engineering', 'exec', 'researcher', 'investor'])"
          />
          <!-- calendly="aaron-patty" -->
        </div>
        <div class="col-md">
          <BioCard
            name="Richard Belnap"
            title="BMG VP Marketing and Sales, Co-Founder"
            bio="15+ years with Johnson and Johnson, Bristol-Myers Squibb, Astellas, ALZA and Sandoz. Entrepreneur &amp; Small Business Owner"
            email="Richard.Belnap@BridgingMedical.com"
            phone="+1 (801) 380-2376"
            pic="bmg-bio-pic-richard-belnap"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['founder', 'exec'])"
            calendly="richard-belnap"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <BioCard
            name="Keith Stolworthy, PH.D"
            title="BioMechanical Engineer"
            bio="BMG Researcher, Investor"
            pic="bmg-bio-pic-stolworthy"
            location="California"
            :show-bio="true"
            :selected="isSelected(['engineering', 'consultant', 'researcher', 'investor'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Tim Lescun, PH.D, DVM"
            title="Large Animal Surgery, Purdue University, College of Veterinary Medicine"
            bio="BMG Researcher, Co-Investigator"
            pic="bmg-bio-pic-lescun"
            location="Indiana"
            :show-bio="true"
            :selected="isSelected(['researcher'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Dustin Williams, PH.D"
            title="Bio-Engineering Researcher"
            bio="Bioengineering Investigator, U. of Utah Orthopaedics – Histology expert"
            pic="bmg-bio-pic-dustin-williams"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['consultant', 'researcher'])"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <BioCard
            name="David Meibos, BSME, MBA, JD"
            title="Registered Patent Attorney"
            bio="Engineer, Medical Device &amp; Orthopedics, BMG Investor"
            pic="bmg-bio-pic-meibos"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['consultant', 'engineering', 'investor'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="Daniel Richards, DO"
            title="BMG Medical Advisory Board"
            bio="Utah Orthopedic surgeon, 12 yrs hip, knee, hand &amp; wrist"
            pic="bmg-bio-pic-daniel-richards"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['medical-board', 'researcher'])"
          />
        </div>
        <div class="col-md">
          <BioCard
            name="David Seegmiller, DPM"
            title="BMG Medical Advisory Board"
            bio="Utah Foot and Ankle Surgery, external fixation expert"
            pic="bmg-bio-pic-seegmiller"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['medical-board'])"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <BioCard
            name="Clark C. Larsen, DPM"
            title="BMG Medical Advisory Board"
            bio="Utah Reconstructive foot &amp; ankle surgeon"
            pic="bmg-bio-pic-clark-larsen"
            location="Utah"
            :show-bio="true"
            :selected="isSelected(['medical-board'])"
          />
        </div>
        <div class="col-md invisible">
          <BioCard
            name=""
            title=""
            bio=""
            pic="bmg-bio-pic-"
            location="<TBD>"
          />
        </div>
        <div class="col-md invisible">
          <BioCard
            name=""
            title=""
            bio=""
            pic="bmg-bio-pic-"
            location="<TBD>"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BioCard from './BioCard'
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
window.$ = require('jquery')
window._ = require('underscore')

export default {
  mixins: [SecurityCheckMixin],
  name: 'TeamPage',
  data: function () {
    return {
      selectedGroups: []
    }
  },
  components: {
    BioCard
  },
  computed: {

  },
  methods: {
    isSelected (_membership) {
      // console.log('size of selectedGroups = ', window._.size(this.selectedGroups))
      if (0 === window._.size(this.selectedGroups)) {
        return true
      } else {
        var intersect = window._.intersection(_membership, this.selectedGroups)
        // console.log('intersect = ', intersect)
        return 0 < window._.size(intersect)
      }
    },
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    }
  },
  beforeMount () {},
  mounted () {
    // console.log('Section = ' + this.$route.params.section)
    this.scrollToSection(this.$route.params.section)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
